import { useCallback, useMemo } from 'react'
import { useIntl } from 'react-intl'
import productLabels from 'i18n/productLabels'
import { getConfigGeographicPlaceId } from 'lib/places/configGeographicPlaceIds'
import { useLocalizedPlaces } from 'hooks/usePlace'

export function useLocalizedConfigLabels(labels: ReadonlyArray<string>) {
  const intl = useIntl()

  const geographicPlaceIds = useMemo(
    () => labels.map(getConfigGeographicPlaceId).filter((id): id is string => !!id),
    [labels],
  )
  const localizedPlaces = useLocalizedPlaces(geographicPlaceIds)

  const productLabelByDefaultMessage = useMemo(
    () => new Map(Object.values(productLabels).map(descriptor => [descriptor.defaultMessage, descriptor])),
    [],
  )

  return useCallback((raw: string): string | undefined => {
    const descriptor = productLabelByDefaultMessage.get(raw)
    if (descriptor) {
      return intl.formatMessage(descriptor)
    }

    const placeId = getConfigGeographicPlaceId(raw)
    if (!placeId) {
      return raw
    }

    return localizedPlaces[placeId]?.place?.name
  }, [intl, localizedPlaces, productLabelByDefaultMessage])
}
